import { FC } from 'react';

import CertificationViewHeader from './CertificationViewHeader';
import CertificationViewBody from './CertificationViewBody';

const CertificationView: FC = () => (
  <div>
    <CertificationViewHeader />

    <CertificationViewBody />
  </div>
);

export default CertificationView;
